import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=fdca6d70&scoped=true"
import script from "./DocumentsList.ts?vue&type=script&lang=ts&external"
export * from "./DocumentsList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdca6d70",
  null
  
)

export default component.exports